<template>
	<div>
		<Select class='' name='send_to_email_address' groupClass='bg-white text-15' placeholder='Select email address'>
			<option :value='null'></option>
            <!-- <option v-for='number in numbers' :value='number.number'>{{ number.fullName }} ({{ $help.e164ToNumber(number.number) }})</option> -->
        </Select>

        <Select class='mt-2' name='template' groupClass='bg-white text-15' :value='null' placeholder='Select template'>
            <option :value='null'></option>
        </Select>

        <TipTap :size='size' ref='body' @change='updateBody' />

        <input type='hidden' name='body' :value='body' />

		<!-- <Textarea name='description' class='mt-2 transition-all duration-500 ease-in-out'
			:textareaClass='["transition-all duration-500 ease-in-out", {
				"min-h-[473px]": size,
				"min-h-[134px]": !size,
			}]'
		/> -->
	</div>
</template>

<script>
	export default {
		props: {
			size: Boolean,
			emails: {
				type: Array,
				default: null
			}
		},

		data() {
			return {
				body: ''
			}
		},

		methods: {
			updateBody(html) {
				return this.body = html;
			}
		},
	}
</script>